import * as req from 'api/actions';
import * as c from './constant';

export const getQuantityMatrixCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_QUANTITY_MATRIX_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantity_matrices`,
    payload,
    callback
  );

export const quantityMatrixCalculationInfo = (id, payload, callback) =>
  req.item(
    c.QUANTITY_MATRIX_CALCULATION_INFO,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantity_matrices`,
    payload,
    callback
  );

export const createQuantityMatrixFees = (id, payload, callback) =>
  req.create(
    c.CREATE_QUANTITY_MATRIX_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantity_matrices`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateQuantityMatrixFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_QUANTITY_MATRIX_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_quantity_matrices/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getNewOtherFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getSingleNewOtherFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );